import { AuthLoginService } from '../../../../../auth-page/service/auth-login.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map, observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DepartmentInterface } from 'src/app/util/interfaces/department';
import { ReportDepartmentInterface } from 'src/app/util/interfaces/department';

@Injectable({
	providedIn: 'root',
})
export class DepartmentService {
	private postDepartmentURL = environment.baseApiUrl + 'department/create';
	private updateDepartmentURL = environment.baseApiUrl + 'department/updateDepartment/{id}';
	private searchDepartmentURL = environment.baseApiUrl + 'department/searchDepartment';
	private getDepartmentURL = environment.baseApiUrl + 'department/searchDepartment';
	private searchResponsibleURL = environment.baseApiUrl + 'department/searchResponsible';
	private deleteDepartmentURL = environment.baseApiUrl + 'department/inactive/{id}';
	private activeDepartmentURL = environment.baseApiUrl + 'department/active/{id}';
	private getReportDepartmentURL = environment.baseApiUrl + 'department/reportDepartment';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	// Todos os departamneto
	getAllDepartment(idCustomer: string): Observable<DepartmentInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.searchDepartmentURL, { headers: headers, params: { customer: idCustomer } });
	}

	// Departamento por id
	getDepartmentById(id: string): Observable<DepartmentInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getDepartmentURL = this.getDepartmentURL + '?id=' + id;
		return this.httpClient.get<any>(getDepartmentURL, { headers: headers }).pipe(
			map((departmentReceived) => {
				departmentReceived = departmentReceived[0];
				const newDepartment: DepartmentInterface = {
					id: departmentReceived.id,
					department: departmentReceived.department,
					active: departmentReceived.active,
					idFull_Name: departmentReceived.responsible_endusers,
					responsible_endusers: departmentReceived.responsible_endusers,
					responsible: departmentReceived.responsible,
					alteration: departmentReceived.alteration,
					items: [],
				};

				if (departmentReceived.items)
					for (const items of departmentReceived.items) {
						newDepartment.items.push({
							full_name: items.full_name,
							email: items.email,
						});
					}
				return newDepartment;
			})
		);
	}

	//  Todos os usuarios
	getAllResponsible(id: string): Observable<DepartmentInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const searchResponsibleURL = this.searchResponsibleURL + '?department=' + id;
		return this.httpClient.get<any[]>(searchResponsibleURL, { headers: headers });
	}

	// Get Responsável pelo departamento
	getResponsibleById(id: string): Observable<DepartmentInterface> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const searchResponsibleURL = this.searchResponsibleURL + '?id=' + id;
		return this.httpClient.get<any>(searchResponsibleURL, { headers: headers }).pipe(
			map((responsibleReceived) => {
				responsibleReceived = responsibleReceived[0];
				const Responsible: DepartmentInterface = {
					idFull_Name: responsibleReceived.idFull_Name,
					responsible: responsibleReceived.responsible,
				};
				return Responsible;
			})
		);
	}

	// Adicionar um departamento
	customDepartment(form: DepartmentInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			department: form.department,
			alteration: form.alteration,
		};
		return this.httpClient.post(this.postDepartmentURL, body, { headers: headers });
	}

	// Atualiza um Departamento
	updateDepartment(formUpdate: DepartmentInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const updateDepartmentURL = this.updateDepartmentURL.replace('{id}', formUpdate.id);
		const body = {
			department: formUpdate.department,
			responsible_endusers: formUpdate.idFull_Name,
			alteration: formUpdate.alteration,
			responsible: formUpdate.responsible,
		};
		return this.httpClient.put(updateDepartmentURL, body, { headers: headers });
	}

	// Deletar/Desativara departamento
	deleteDepartment(customDepartment: DepartmentInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteDepartmentURL = this.deleteDepartmentURL.replace('{id}', customDepartment.id);
		const body = {
			department: customDepartment.department,
			responsible_endusers: customDepartment.idFull_Name,
			alteration: customDepartment.alteration,
		};
		return this.httpClient.put<any>(deleteDepartmentURL, body, { headers: headers });
	}

	// Ativar o departamento
	activeDepartment(customDepartment: DepartmentInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const activeDepartmentURL = this.activeDepartmentURL.replace('{id}', customDepartment.id);
		const body = {
			department: customDepartment.department,
			responsible_endusers: customDepartment.idFull_Name,
			alteration: customDepartment.alteration,
		};
		return this.httpClient.put<any>(activeDepartmentURL, body, { headers: headers });
	}

	// Logs departamento
	getReportDepartment(id: number): Observable<ReportDepartmentInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getReportDepartmentURL = this.getReportDepartmentURL + '?id_department=' + id;
		return this.httpClient.get<ReportDepartmentInterface[]>(getReportDepartmentURL, { headers: headers });
	}
}
